import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FileMenuRequestBody, FileMenuResponse } from "./types";

export class FileMenuJson extends BaseAPI<
  FileMenuRequestBody,
  FileMenuResponse
> {
  protected route = ApiRoutes.file.menu;
  protected method = RequestMethod.GET;
}
